import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Play } from 'lucide-react';
import { getDirectUrl } from '../../utils/mediaUtils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FeaturedCard = ({ video }) => (
  <Link
    to={`/videos/featured/${video.slug}`}
    className="group block bg-white border border-slate-200 rounded overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
    data-testid={`featured-video-card-${video.slug}`}
  >
    <div className="relative aspect-video bg-brand-primary overflow-hidden">
      <img
        src={getDirectUrl(video.cover_url)}
        alt={video.title}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-contain group-hover:scale-[1.03] transition-transform duration-500"
        data-testid={`featured-video-cover-${video.slug}`}
      />
      <span className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/30 transition-colors duration-300">
        <span className="h-16 w-16 rounded-full bg-brand-accent/95 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300" data-testid={`featured-video-play-${video.slug}`}>
          <Play className="h-7 w-7 text-white ml-1" fill="currentColor" />
        </span>
      </span>
    </div>
    <div className="p-5">
      <h3 className="font-heading text-xl font-semibold text-brand-primary leading-snug mb-2" data-testid={`featured-video-title-${video.slug}`}>{video.title}</h3>
      {video.description && <p className="font-body text-sm text-slate-600 leading-relaxed line-clamp-3">{video.description}</p>}
    </div>
  </Link>
);

export const FeaturedVideosSection = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    axios.get(`${API}/featured-videos`).then(({ data }) => setVideos(data)).catch(() => setVideos([]));
  }, []);

  if (!videos.length) return null;

  return (
    <section className="py-16 md:py-20 bg-background-tertiary border-b border-slate-200" data-testid="featured-videos-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-xs font-semibold tracking-[0.3em] uppercase text-brand-accent mb-3">Watch & Download</p>
        <h2 className="font-heading text-3xl md:text-4xl font-semibold text-brand-primary mb-10">Featured Videos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="featured-videos-grid">
          {videos.map((v) => <FeaturedCard key={v.id} video={v} />)}
        </div>
      </div>
    </section>
  );
};
